import { FaqPartType } from "../components/PuxRepeater/PuxRepeaterParts/FaqPart"
import { getRepeaterQuery } from "../queries/repeater-queries"
import { puxGraphqlHelper } from "./data/puxGraphqlHelper"

interface ContentItemQueryResult {
  easySoftwareFaq: FaqPartType[]
}

export const getFAQItems = async (contentItemIds: string[], limit?: number, sort?: boolean, preferedContentLinkCulture?: string): Promise<FaqPartType[]> => {
  const contentItemQuery = `
      {
          orchard {
              ${getRepeaterQuery({ contentType: "EasySoftwareFaq", itemIdsArray: contentItemIds, limit: contentItemIds?.length ?? 3, sort: sort ?? false, preferedContentLinkCulture: preferedContentLinkCulture?.toLowerCase() ?? "" })}
          }
      }
  `


  const contentItemNode = await puxGraphqlHelper<ContentItemQueryResult>(contentItemQuery, {
    errorMetadata:
    {
      message: `Error while running GraphQL query in getWidgetsFromOrchardWidgetZone for contentItemId:${contentItemIds}`,
    }
  })

  if (!contentItemNode?.easySoftwareFaq) {
    throw `Error: contentItemNode.contentItem is null or undefined in getWidgetsFromOrchardWidgetZone for contentItemId:${contentItemIds}`
  }

  return contentItemNode.easySoftwareFaq
}
